// extracted by mini-css-extract-plugin
export default {"image":"style_image__yVbfF","primaryImg":"style_primaryImg__7QXVI"};